import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import View from './View';
import Sidebar from './Sidebar';

const Edit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <View data={data} isEditMode={true} />

      <SidebarPortal selected={selected}>
        <Sidebar
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};
export default Edit;
